var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvangardLogoWithoutOnline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 175,
    height: 207,
    viewBox: "0 0 175 207",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9198 162.565H6.79473L5.64718 165.905H0.320496L7.63398 146.705H13.0805L20.394 165.905H15.0673L13.9198 162.565ZM12.601 158.78L10.3573 152.391L8.11356 158.78H12.601Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6523 146.705H33.0856C34.8498 146.705 36.1857 147.133 37.1106 147.972C38.0356 148.828 38.4808 150.045 38.4808 151.638C38.4808 152.613 38.3095 153.401 37.967 154.053C37.6245 154.686 37.0935 155.234 36.3742 155.662C37.0935 155.8 37.693 156.004 38.1897 156.279C38.6864 156.553 39.0974 156.896 39.4057 157.307C39.714 157.717 39.9367 158.18 40.0737 158.676C40.2107 159.191 40.2792 159.739 40.2792 160.303C40.2792 161.211 40.1252 161.999 39.8168 162.702C39.5085 163.404 39.0632 163.987 38.498 164.466C37.9328 164.946 37.2306 165.305 36.4256 165.528C35.6206 165.75 34.6956 165.887 33.668 165.887H25.6523V146.705ZM30.6535 154.241H31.5784C33.1371 154.241 33.925 153.624 33.925 152.391C33.925 151.157 33.1371 150.524 31.5784 150.524H30.6535V154.241ZM30.6535 162.034H31.7497C33 162.034 33.9077 161.879 34.4559 161.554C35.0039 161.229 35.278 160.715 35.278 159.995C35.278 159.276 35.0039 158.763 34.4559 158.437C33.9077 158.112 33.0172 157.957 31.7497 157.957H30.6535V162.034Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8349 162.565H50.7098L49.5623 165.905H44.2356L51.532 146.705H56.9785L64.292 165.905H58.9653L57.8349 162.565ZM56.4989 158.78L54.2552 152.391L52.0115 158.78H56.4989Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5515 154.121H81.7623V146.705H86.7636V165.905H81.7623V157.992H74.5515V165.905H69.5674V146.705H74.5515V154.121Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.8372 165.905V146.705H104.816V150.935H98.8213V165.905H93.8372Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.183 162.565H115.058L113.911 165.905H108.584L115.898 146.705H121.344L128.657 165.905H123.331L122.183 162.565ZM120.865 158.78L118.621 152.391L116.377 158.78H120.865Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.917 165.905H133.933V146.705H141.88C144.038 146.705 145.682 147.27 146.83 148.383C147.977 149.496 148.543 151.09 148.543 153.127C148.543 155.165 147.977 156.741 146.83 157.872C145.682 159.002 144.021 159.55 141.88 159.55H138.917V165.905ZM138.917 155.525H140.578C142.411 155.525 143.336 154.721 143.336 153.127C143.336 151.534 142.411 150.73 140.578 150.73H138.917V155.525Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.966 161.674C155.617 161.674 156.027 161.486 156.233 161.109C156.438 160.732 156.524 160.167 156.524 159.448V146.705H172.265V161.674H174.679V169.485H169.712V165.887H158.169V169.485H153.202V161.674H154.966ZM167.263 150.935H161.509V159.499C161.509 159.995 161.491 160.407 161.474 160.749C161.44 161.091 161.389 161.4 161.303 161.691H167.263V150.935Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.2568 47.2742H22.1155L35.9269 57.7615H59.66L63.2568 47.2742Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7922 74.9173L61.9232 77.5341L62.7922 74.9173Z",
    fill: "#3DF0F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.744 47.2742L115.33 57.7615H139.073L152.885 47.2742H111.744Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.654 64.248L120.231 72.1187L130.314 64.248H117.654Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2554 64.248L54.679 72.1187L44.5957 64.248H57.2554Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.697 124.91L87.4951 0L46.3033 124.91L62.0142 113.745L87.4951 33.7759L112.552 113.442L128.697 124.91Z",
    fill: "#DA291C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.6679 84.7884L87.7174 81.6968L83.3527 85.0107L77.6948 102.763L87.7174 95.6496L97.3056 102.459L91.6679 84.7884Z",
    fill: "#DA291C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 174.359,
    height: 170,
    fill: "white",
    transform: "translate(0.320496)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvangardLogoWithoutOnline);
export default __webpack_public_path__ + "static/media/avangard-logo-without-online.e85f96d5.svg";
export { ForwardRef as ReactComponent };